export const schoolIcons = {
    Attendiz: require('./attendiz.png').default,
    Carmel: require('./carmel.svg').default,
    Stedelijk: require('./stedelijk.png').default,
    Nordik: require('./nordik.png').default,
    Osg: require('./osg_almelo_hengelo.svg').default,
    Portuur: require('./portuur.svg').default,
    Reggesteyn: require('./reggesteyn.svg').default,
    Rvt: require('./roc_van_twente.svg').default,
    Waerdenborch: require('./waerdenborch.png').default,
    DePassie: require('./de_passie.svg').default,
    Greijdanus: require('./greijdanus.svg').default,
    ZoneCollege: require('./zone_college.svg').default,
}
